import React, { useState, useContext } from 'react';
import { Box, AppBar, Toolbar, IconButton, Typography, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import SupportAgent from '@mui/icons-material/SupportAgent';
import ChatIcon from '@mui/icons-material/Chat';
import { AuthContext } from '../auth/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import logoImg from '../assets/logo.png';
import ContrattoBanner from '../components/ContrattoBanner';
import NotificheBadge from '../components/NotificheBadge';

const drawerWidth = 240;

export default function AppLayoutMobile() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const firstLetter = user?.username ? user.username.charAt(0).toUpperCase() : '?';

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const items = [
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Dashboard', to: '/dashboard', icon: <DashboardIcon /> }]
      : []),
    ...(user?.role === 'STUDIO' && user?.studioId
      ? [{ label: 'Dashboard', to: `/dashboard/studio/${user.studioId}`, icon: <DashboardIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE'
      ? [{ label: 'Dashboard', to: `/dashboard/contribuente/${user.contribuenteId}`, icon: <DashboardIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Utenti', to: '/users', icon: <PeopleIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Studi', to: '/studi', icon: <BusinessIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Audit', to: '/audit', icon: <PeopleIcon /> }]
      : []),
    ...(user?.role === 'ADMIN'
      ? [{ label: 'Contribuenti', to: '/contribuenti', icon: <FolderIcon /> }]
      : []),
    ...(user?.role === 'STUDIO'
      ? [{ label: 'Contribuenti', to: `/contribuenti/bystudio/${user.studioId}`, icon: <FolderIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE'
      ? [{ label: 'Documenti e Scadenze', to: `/documenti/bycontribuente/${user.contribuenteId}`, icon: <DescriptionIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE'
      ? [{ label: 'Genera report', to: `/contribuenti/report/${user.contribuenteId}`, icon: <DescriptionIcon /> }]
      : []),
    ...(user?.role === 'CONTRIBUENTE'
      ? [{ label: 'Il mio Fascicolo', to: '/fascicolo/me', icon: <FolderIcon /> }]
      : []),
    ...[{ label: 'Tickets', to: '/tickets', icon: <SupportAgent /> }],
      ...(user?.chatisactive === true
       ? [{ label: 'Chat', to: '/chatrooms', icon: <ChatIcon /> }]
       : []),
     ...(user?.role === 'CONTRIBUENTE' && user?.calendarEnabled
       ? [
           !user.googleCalendarEnabled
             ? { label: 'Abilita notifiche Google Calendar', onClick: handleEnableCalendar, icon: <CalendarTodayIcon /> }
             : { label: 'Disabilita notifiche Google Calendar', onClick: handleDisableCalendar, icon: <CalendarTodayIcon /> }
         ]
       : [])
    // aggiungere altre voci semplificate se serve
  ];

  const drawer = (
    <Box sx={{ width: drawerWidth }} role="presentation" onClick={handleDrawerToggle}>
      <Box sx={{ textAlign: 'center', my: 2 }}>
        <img src={logoImg} alt="Logo" style={{ maxWidth: '120px' }} />
      </Box>
      <List>
        {items.map(i => {
          const selected = location.pathname.startsWith(i.to);
          return (
            <ListItemButton key={i.to} selected={selected} onClick={() => navigate(i.to)}>
              <ListItemIcon>{i.icon}</ListItemIcon>
              <ListItemText primary={i.label} />
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed">
      <NotificheBadge />
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <IconButton color="inherit" edge="start" onClick={handleDrawerToggle}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>Scadenze & Gestione Studio</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography>
            {user?.nomecognomeutente || 'Guest'} ({user?.role || '-'}) {user?.role==='STUDIO'?'Codice invito: '+user?.codiceInvito:''}
          </Typography>
          <Avatar>{firstLetter}</Avatar>
            <IconButton color="inherit" onClick={handleLogout}>
              <LogoutIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { width: drawerWidth } }}
      >
        {drawer}
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 2, mt: 8 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
